import { Injectable } from '@angular/core';
import * as activityDataObj from '../../shared/content/activityData.json';

// import * as $ from 'jquery';
declare var $: any;
@Injectable()
export class interActivityServices {
  public activityData = (<any>activityDataObj).activityData;

  public videoSrc: null;
  public videoElement: any;
  public isShowStartBg: boolean;
  public isShowPopUp: boolean = false;
  public isShowPlay: boolean = true;
  public isVideoStarted: boolean = true;
  public isVideoEnded: boolean = false;
  public isVideoMuted:boolean = false;
  public videoTimelineTxt: any;
  public videoPlayflag: boolean = true;
  public audioPlaying: boolean = false;
  public nextButton: boolean = true;
  public previousButton: boolean = true;
  constructor() {

  }


  pauseVideo() {
    this.videoElement.pause();
    this.isVideoStarted = false;
  }
  playVideo() {
    var self = this;
    self.videoElement.play();
    self.isVideoStarted = false;
    this.videoElement.onended = function () {
      self.pauseVideo();
      self.isShowPlay = true;
      self.isVideoEnded = true;
      self.audioPlaying = false;
      setTimeout(function () {
        $("#playPauseBtn").attr("tabindex", -1)
      }, 70)
      $('#nextButton').removeClass('btnactive');
      $('.playBtnWrapper').addClass('disabledPlayPause')
      $('#nextButton').addClass('disabledBtn').attr("tabindex", -1)
    }
    this.videoElement.ontimeupdate = function (event) {
      if (self.videoElement.currentTime >= 0 && self.isShowStartBg) {
        self.pauseVideo();
      }
      if (self.videoElement.currentTime > 0.1) {
        // if ($('.videoPoster').is(":visible")) {
        //   self.videoElement.currentTime = 0;
        // }
        $('.videoPoster').hide();
      }
      // let evt = new CustomEvent('videoValuechanged', {
      //   detail: {
      //     "time": self.videoElement.currentTime
      //   }
      // });
      // document.dispatchEvent(evt)

      var evt = document.createEvent('Event');
      evt.initEvent('videoValuechanged', true, true);
      evt["time"] = self.videoElement.currentTime
      document.dispatchEvent(evt);

      if(self.videoElement.currentTime > 0) {
        self.nextButton = false;
        $('#nextButton').removeClass('disabledBtn')

      }

      if(self.videoElement.currentTime >= 44.5) {
        self.nextButton = true;
        // console.log('self.nextButton = ' + self.nextButton);
        $('#nextButton').addClass('disabledBtn')


      }

      if (self.videoElement.currentTime < 13.8) {
        self.previousButton = true;
      }
      else {
        self.previousButton = false;
      }
    }
  }

  disableNextBtn() {
    $('#nextButton').addClass('disabledBtn')
  }

  muteVideo() {
  this.isVideoMuted = true;
  this.videoElement.muted = this.isVideoMuted;
  // console.log(this.isVideoMuted)
  }
  unMuteVideo() {
    this.isVideoMuted = false;
    this.videoElement.muted = this.isVideoMuted;
  }

}
